import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ComponentFactoryResolver, ApplicationRef, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//import full calendar and plugin
import { FullCalendarModule } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';

import { AppComponent } from './app.component';
import { SearchComponent } from './Components/search.component';
import { SearchFilterService } from './Services/search-filter.service'
import { HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FamilyeventAlbumComponent } from './Components/familyevent-album.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxSpinnerModule } from 'ngx-spinner';
import { FamilyEventComponent } from './Components/family-event.component';
import { NoopAnimationsModule, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SsrsReportComponent } from './Components/ssrs-reports.component';
import { ssrsReportsService } from './Services/ssrs-reports.service';
import { EscapeHtmlPipe } from './Models/keep-html.pipe';
import { SearchContractComponent } from './Components/search-contract.component';
import { SearchContractPipe } from './Models/search-contract.pipe';
import { ContractSearchService } from './Services/contract-search.service';
import { ResolutionViewService } from './Services/resolution-view.service';
import { FamilyeventGallaryService } from './Services/familyevent-gallary.service';
import { ArticlesListComponent } from './Components/articles-list.component';
import { SearchContractHeaderComponent } from './Components/search-contract-header.component';
import { EventCalendarComponent } from './Components/event-calendar.component';
import { PodcastListComponent } from './Components/podcast-list.component';
import { PodcastModalComponent } from './Components/podcast-modal.component';
import { GlobalSearchComponent } from './Components/global-search.component';
import { GlobalSearchService } from './Services/global-search.service';
import { PolicyManualContentComponent } from './Components/policy-manual-content.component';
import { ListViewContentPipe } from './Models/listview-content.pipe';
import { PolicyManualHeaderComponent } from './Components/policy-manual-header.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { VideoSearchComponent } from './Components/video-search.component';
import { VideoModalPopupComponent } from './Components/video-modal-popup.component';
import { InternalarticleSearchComponent } from './components/internalarticle-search.component';
import { ResolutionViewComponent } from './components/resolution-view.component';
import { TtgaPairingComponent } from './components/ttga-pairing.component';
import { AgGridModule } from 'ag-grid-angular';
import { TtgaPairingService } from './Services/ttga-pairing.service';
import { QnASearchService } from './Services/qna-search.service';
import { TocTabPageQnAViewAllComponent } from './components/toctabpage-qna-viewall.component';
import { NetZeroPreferencesComponent } from './components/netzero-preferences.component';
import { TocTabPageQnAViewAllAnswersComponent } from './Components/toctabpage-qna-viewall-answers.component';
import { DTCPreferencesComponent } from './components/dtc-preferences.component';
import { DatepickerDirective } from './Models/datepicker.directive';
import { QnaReportDownloadComponent } from './Components/qna-report-download.component';
import { QnaReportDownloadService } from './Services/qna-report-download.service';
import { DisablityCalculatorComponent } from './Components/disablity-calculator.component';
// register FullCalendar plugins
FullCalendarModule.registerPlugins([
    dayGridPlugin, listPlugin
]);

@NgModule({
    declarations: [
        AppComponent,
        SearchComponent,
        FamilyeventAlbumComponent,
        FamilyEventComponent,
        ArticlesListComponent,
        SsrsReportComponent,
        EscapeHtmlPipe,
        SearchContractComponent,
        SearchContractPipe,
        SearchContractHeaderComponent,
        EventCalendarComponent,
        PodcastListComponent,
        PodcastModalComponent,
        GlobalSearchComponent,
        PolicyManualContentComponent,
        ListViewContentPipe,
        PolicyManualHeaderComponent,
        VideoSearchComponent,
        VideoModalPopupComponent,
        InternalarticleSearchComponent,
        ResolutionViewComponent,
        TtgaPairingComponent,
        TocTabPageQnAViewAllComponent,
        NetZeroPreferencesComponent,
        TocTabPageQnAViewAllAnswersComponent,
        DTCPreferencesComponent,
        DatepickerDirective,
        QnaReportDownloadComponent,
        DisablityCalculatorComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        NgbModule,
        InfiniteScrollModule,
        NgxSpinnerModule,
        NoopAnimationsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FullCalendarModule,
        NgMultiSelectDropDownModule.forRoot(),
        AgGridModule.withComponents([QnaReportDownloadComponent])
    ],
    entryComponents: [SearchComponent, FamilyeventAlbumComponent, FamilyEventComponent, SsrsReportComponent, SearchContractComponent, ArticlesListComponent, SearchContractHeaderComponent, EventCalendarComponent, PodcastListComponent, PodcastModalComponent, GlobalSearchComponent, PolicyManualContentComponent, PolicyManualHeaderComponent, VideoSearchComponent, VideoModalPopupComponent, InternalarticleSearchComponent, ResolutionViewComponent, TtgaPairingComponent, TocTabPageQnAViewAllComponent, NetZeroPreferencesComponent, TocTabPageQnAViewAllAnswersComponent, DTCPreferencesComponent, QnaReportDownloadComponent,DisablityCalculatorComponent],
    providers: [SearchFilterService, ssrsReportsService, FamilyeventGallaryService, ContractSearchService, GlobalSearchService, ResolutionViewService, TtgaPairingService, QnASearchService, QnaReportDownloadService]
    //bootstrap: [AppComponent]
})
export class AppModule {

    constructor(private resolver: ComponentFactoryResolver) { }

    ngDoBootstrap(appRef: ApplicationRef) {
        [SearchComponent, FamilyeventAlbumComponent, FamilyEventComponent, SsrsReportComponent, SearchContractComponent, ArticlesListComponent, SearchContractHeaderComponent, EventCalendarComponent, PodcastListComponent, PodcastModalComponent, GlobalSearchComponent, PolicyManualContentComponent, PolicyManualHeaderComponent, VideoSearchComponent, VideoModalPopupComponent, InternalarticleSearchComponent, ResolutionViewComponent, TtgaPairingComponent, TocTabPageQnAViewAllComponent, NetZeroPreferencesComponent, TocTabPageQnAViewAllAnswersComponent, DTCPreferencesComponent, QnaReportDownloadComponent,DisablityCalculatorComponent].forEach((componentDef: Type<{}>) => {
            const factory = this.resolver.resolveComponentFactory(componentDef);
            if (document.querySelector(factory.selector)) {
                appRef.bootstrap(factory);
            }
        });
    }
}
